/**
 * Formats a numeric price value to a consistent 2-decimal string.
 * Use this instead of .toFixed(2) or .toLocaleString() directly.
 *
 * @param {number|null|undefined} price
 * @returns {string} e.g. "12.50", "0.00"
 */
export const formatPrice = (price) => {
  if (price == null || isNaN(price)) return '0.00';
  return Number(price).toFixed(2);
};
